(ns net.kestec.mhda-pilgrimage.util.date
  (:require
    [goog.string :as gstring]
    ["date-fns" :as fns]
    ["date-fns/locale" :refer [de]]
    ["@date-fns/tz" :refer [tz]]
    ))



(defn now []
  (js/Date.))

(defn add-days [d i]
  (fns/addDays d i))





(defn parse-iso [s]
  (fns/addMinutes (js/Date. s) (.getTimezoneOffset (js/Date. s))))

(defn parse-restDay [s]
  (fns/parse s "yyyyMMdd" (js/Date.)))


(defn format-restDay [d]
  (fns/format d "yyyyMMdd"))


(defn format-timeShort [d]
  (fns/format d "dd.MM HH:mm" #js {"locale" de}))

(defn format-ger [d]
  (fns/format d "cccccc dd.MM.yyyy HH:mm" #js {"locale" de}))

(defn format-gerShort [d]
  (fns/format d "cccccc dd.MM. HH:mm" #js {"locale" de}))

(defn format-gerDayShort [d]
  (fns/format d "cccccc dd.MM." #js {"locale" de}))


